<template>
    <div>
        <v-icon
            v-if="isTaskStatusAvailable(task) && isTaskStatusDone(task)"
            @click="openTaskStatusDialog(task)"
            color="success"
            >$check-circle</v-icon
        >
        <v-icon
            v-if="isTaskStatusAvailable(task) && !isTaskStatusDone(task)"
            @click="openTaskStatusDialog(task)"
            color="light-gray"
            >$radiobox-blank</v-icon
        >
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { isTaskStatusAvailable, isTaskStatusDone } from "@/lib/taskUtils";

export default defineComponent({
    props: {
        task: {
            type: Object,
            required: true,
        },
    },
    emits: ["openTaskStatusDialog"],
    methods: {
        isTaskStatusAvailable(task) {
            return isTaskStatusAvailable(task);
        },
        isTaskStatusDone(task) {
            return isTaskStatusDone(task);
        },
        openTaskStatusDialog(task) {
            this.$emit("openTaskStatusDialog", task);
        },
    },
});
</script>
